import { MESSAGE_STATUS_TOAST_MAP } from '../../constants/messageStatusToastMap';
import { useToast } from '../../lib/chakraUi/hooks';
import { User } from '../../types';
import { useSubscribeToUserMessage } from '../../websocketApi/user';

export const useUserMessageNotification = (userId: User['id']): void => {
  const toast = useToast();

  useSubscribeToUserMessage(userId, ({ message, status, title }) => {
    toast({
      description: message,
      closable: true,
      title,
      type: MESSAGE_STATUS_TOAST_MAP[status] ?? 'info',
    });
  });
};
